import getRequest from '../../../getRequest';

/**
 * Get all Brands from PRISM db.
 *
 * @returns {[
 *   {
 *    brandId: number,
 *    name: string
 *   }
 * ]}
 */
export default async function getLatestIndexJobDetails() {
  const endpoint = '/oc-product/v1/index';

  return new Promise((resolve, reject) => {
    getRequest(endpoint, 'Get Index Latest Job Details')
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  });
}
